import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CountryCode from "../../Components/CountryCode";
import CustomButton from "../../Components/CustomButton";
import MainHeader from "../../Components/MainHeader/MainHeader";
import ModalWarning from "../../Components/ModalWarning/ModalWarning";
import LangSwitcher from "../../Components/LangSwitcher";
import EmailInput from "../../Components/EmailInput";

import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";
import { ReactComponent as Exclamation } from "../../static/images/exclamation_sign.svg";

import "./style.scss";

const Main = () => {
  const [resetPassInputEmail, setResetPassInputEmail] = useState("");
  const [resetPassInputPhone, setResetPassInputPhone] = useState("");

  const [warningModalToggle, setWarningModalToggle] = useState("");
  const [warningModalText, setWarningModalText] = useState("");
  const [warningButtonText, setWarningButtonText] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { pathname } = useLocation();

  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));

  const [selected, setSelected] = useState("mobile");

  const handleToggle = (active) => {
    setSelected(active);
  };

  const handleEmailInputChange = (e) => {
    setResetPassInputEmail(e.target.value);
  };

  const handlePhoneInputChange = (value) => {
    setResetPassInputPhone(value);
  };

  const sendLoginLink = async (e) => {
    e.preventDefault();
    const resetPassInput =
      selected === "mobile" ? resetPassInputPhone : resetPassInputEmail;

    fetch(
      `${process.env.REACT_APP_BASE_URL}/User/reset-password?Identifier=${encodeURIComponent(resetPassInput)}`,
    ).then((response) => {
      if (response.status === 200) {
        setWarningModalToggle("modal-warning");
        setWarningModalText(t("reset_link_sent"));
        setWarningButtonText({
          text: t("go_login_page"),
          func: () => {
            navigate("/");
          },
        });
      } else {
        setWarningModalToggle("modal-warning");
        setWarningModalText(t("error_account_not_found"));
        setWarningButtonText({ text: t("close"), func: () => {} });
      }
    });
  };

  useEffect(() => {
    if (ps10005000 && pathname === "/") {
      navigate("sessions");
      return;
    }
  }, [ps10005000, navigate]);

  return (
    <>
      <ModalWarning
        warningText={warningModalText}
        changeModal={setWarningModalToggle}
        modalValue={warningModalToggle}
        buttonText={warningButtonText.text}
        Image={warningButtonText.text === t("close") ? Exclamation : Tick}
        handleButton={warningButtonText.func}
      />

      <MainHeader />
      <div className="reset-password">
        <div className="reset-text">
          <span>{t("reset_password_info")}</span>
        </div>
        <form
          onSubmit={(e) => {
            sendLoginLink(e);
          }}
        >
          <div className="toggle-container-login">
            <span
              className={`toggle-label ${selected === "mobile" ? "active" : ""}`}
              onClick={() => handleToggle("mobile")}
            >
              {t("createSchedule.inviteCustomers.toggle_mobile")}
            </span>

            <div className="toggle-switch">
              <input
                type="checkbox"
                id="toggle"
                className="toggle-input"
                checked={selected === "email"}
                onChange={() =>
                  handleToggle(selected === "mobile" ? "email" : "mobile")
                }
              />
              <label htmlFor="toggle" className="toggle-label-switch"></label>
            </div>

            <span
              className={`toggle-label ${selected === "email" ? "active" : ""}`}
              onClick={() => handleToggle("email")}
            >
              {t("createSchedule.inviteCustomers.toggle_email")}
            </span>
          </div>
          {selected === "mobile" ? (
            <CountryCode
              phone={resetPassInputPhone}
              changePhone={handlePhoneInputChange}
              size="medium"
            />
          ) : (
            <EmailInput
              label={t("input_label_email")}
              email={resetPassInputEmail}
              onChange={handleEmailInputChange}
              size="medium"
              required
            />
          )}
          <CustomButton fullWidth type="submit" fontSize="1.2rem">
            {t("send_login_link")}
          </CustomButton>

          <CustomButton
            fullWidth
            fontSize="1.2rem"
            color="primary"
            onClick={() => {
              navigate("/");
            }}
          >
            {t("go_login_page")}
          </CustomButton>
        </form>

        <div className="main-pages-langswitcher">
          <LangSwitcher />
        </div>
      </div>
    </>
  );
};

export default Main;
